import { Controller } from "remult";

@Controller("vehicle-methods")
export class VehicleMethods {}
